import { useState } from 'react';

import CheckoutGreeting, { firstNameOf } from '@checkout/components/CheckoutGreeting';
import CountrySelector from '@checkout/components/CountrySelector';
import Input from '@components/Input';
import Text from '@components/Text';
import payload from '@app/payload';
import { t } from '@i18n';

import type { LocaleInfo } from '@i18n';

import type { CheckoutValuesRef } from '../types';

interface CheckoutContactScreenProps {
  valuesRef: CheckoutValuesRef;
  selectedCountry: string;
  locale: LocaleInfo;
  usdAvailable: boolean;
  onCountryChange: (country: string) => void;
}

export function CheckoutContactScreen({
  valuesRef,
  selectedCountry,
  locale,
  usdAvailable,
  onCountryChange,
}: CheckoutContactScreenProps) {
  const [firstName, setFirstName] = useState(() => firstNameOf(valuesRef.current.name));

  return (
    <>
      <div className='checkout-form-topbar'>
        <Text.subheading className='checkout-eyebrow'>{t('common.checkout')}</Text.subheading>
        <CountrySelector
          value={selectedCountry}
          usdAvailable={usdAvailable}
          locale={locale}
          onChange={onCountryChange}
        />
      </div>

      <div className='checkout-form-title'>
        <CheckoutGreeting firstName={firstName} />
        <Text.h3>{t('checkout.title')}</Text.h3>
        <Text.p contrast={6}>{t('checkout.subtitle', { productName: payload.name })}</Text.p>
      </div>

      <Text.h5 className='mt-3'>{t('checkout.contactInfo')}</Text.h5>
      <div className='input-group'>
        <Input.FullName
          data-error='name'
          bypassStyles
          placeholder={t('checkout.contact.namePlaceholder')}
          value={valuesRef.current.name}
          onInput={(value: string) => { valuesRef.current.name = value; }}
          onBlur={(value: string) => setFirstName(firstNameOf(value))}
        />
        <Input.Email
          data-error='email'
          bypassStyles
          placeholder={t('input.email.placeholder')}
          value={valuesRef.current.email}
          onInput={(value: string) => { valuesRef.current.email = value; }}
        />
        <Input.Phone
          data-error='phone'
          bypassStyles
          placeholder={t('input.phone.placeholder')}
          value={valuesRef.current.phone}
          country={selectedCountry}
          onInput={(value: any) => { valuesRef.current.phone = value; }}
        />
      </div>
    </>
  );
}
